export const QUOTES = [
    {text: "Difficile è la lotta contro il desiderio, poiché ciò che esso vuole lo compra a prezzo dell'anima.",
      author: "Eraclito"
    },
    {
      text: "La filosofia è la musica più grande. La filosofia è musica perenne. La musica è amore di bellezza. Colui che possiede anima musicale potrà amare gli uomini.",
      author: "Platone"
    },
    {
      text: "La filosofia non serve a nulla, dirai; ma sappi che, proprio perchè priva del legame di servitù, è il sapere più nobile.",
      author: "Aristotele"
    },
    {
      text: "E' bene riflettere sulle cose che possono farci felici; infatti, se siamo felici, abbiamo tutto ciò che ci occorre; se non lo siamo, facciamo tutto per esserlo.",
      author: "Epicuro"
    },
    {
      text: "Ciò che turba gli uomini non sono le cose, ma le opinioni che essi hanno delle cose.",
      author: "Epitteto"
    },
    {
        text: "Ricordati che l'uomo non vive altra vita che quella che vive in questo momento, né perde altra vita che quella che perde adesso.",
        author: "Marco Aurelio"
      },
      {
        text: "Non cercar di sapere, interrogando le stelle, che cosa Dio ha in mente di fare: quello che decide su di te, lo decide sempre senza di te.",
        author: "Seneca"
      },
      {
        text: "Mi capita anche questo: che io non mi trovi più dove mi cerco; e trovi me stesso più per caso che per l'indagine della mia mente. ",
        author: "Michel De Montaigne"
      },
      {
        text: "L'uomo tanto può quanto sa. Il dominio dell'uomo consiste solo nella conoscenza.",
        author: "Francesco Bacone"
      },
      {
        text: "Gli uomini adoperano il pensiero solo per giustificare le loro ingiustizie, e impiegano le loro parole solo per travestire i loro pensieri. ",
        author: "Voltaire"
      }
  ];